import ENTITY_TYPES from "../constants/entityTypes";
import INQUIRY_TYPES from "../constants/inquiryTypes";

const getContactPreferences = ({ contact_preferences }) =>
  Object.keys(contact_preferences)
    .filter(k => contact_preferences[k])
    .join(",");

const eventCategories = {
  [ENTITY_TYPES.sale]: "sales_show",
  [ENTITY_TYPES.building]: "buildings_show",
  [ENTITY_TYPES.property]: "sell_homepage"
};

const eventData = {
  [INQUIRY_TYPES.interested_seller]: {
    eventAction: "sell_your_home",
    eventLabelOpen: "open",
    eventLabelSubmit: () => "submit"
  },
  [INQUIRY_TYPES.streeteasy_valuation]: {
    eventAction: "claim_your_home",
    eventLabelOpen: "open_contact_form",
    eventLabelSubmit: () => "submit_contact_form"
  },
  [INQUIRY_TYPES.seller_landing_valuation]: {
    eventAction: "claim_your_home",
    eventLabelSubmit: values =>
      `submit_contact_form|contact_prefer:${getContactPreferences(values)}`
  },
  [INQUIRY_TYPES.seller_landing_contact]: {
    eventAction: "contact_us",
    eventLabelSubmit: () => "submit"
  }
};

export const sendInquirySuccessGAEvent = (
  entityType,
  inquiryType,
  formValues
) => {
  const eventCategory = eventCategories[entityType] ?? "sell_homepage";

  global.dataLayer.push({
    event: "custom_event",
    event_category: eventCategory,
    event_action: eventData[inquiryType].eventAction,
    event_label: eventData[inquiryType].eventLabelSubmit(formValues)
  });
};
